import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import arCommon from './locales/ar/common.json';
import arOrders from './locales/ar/orders.json';
import arCustomers from './locales/ar/customers.json';
import arImports from './locales/ar/imports.json';
import arKpis from './locales/ar/kpis.json';
import arOnboardingWizard from './locales/ar/onboarding-wizard.json';
import arOrderCreation from './locales/ar/order-creation.json';
import arSettings from './locales/ar/settings.json';
import arSignup from './locales/ar/signup.json';
import arTasks from './locales/ar/tasks.json';
import enCommon from './locales/en/common.json';
import enOrders from './locales/en/orders.json';
import enCustomers from './locales/en/customers.json';
import enImports from './locales/en/imports.json';
import enKpis from './locales/en/kpis.json';
import enOnboardingWizard from './locales/en/onboarding-wizard.json';
import enOrderCreation from './locales/en/order-creation.json';
import enSettings from './locales/en/settings.json';
import enSignup from './locales/en/signup.json';
import enTasks from './locales/en/tasks.json';
import frCommon from './locales/fr/common.json';
import frOrders from './locales/fr/orders.json';
import frCustomers from './locales/fr/customers.json';
import frImports from './locales/fr/imports.json';
import frKpis from './locales/fr/kpis.json';
import frOnboardingWizard from './locales/fr/onboarding-wizard.json';
import frOrderCreation from './locales/fr/order-creation.json';
import frSettings from './locales/fr/settings.json';
import frSignup from './locales/fr/signup.json';
import frTasks from './locales/fr/tasks.json';

import { SUPPORTED_LANGUAGES } from '@klareospace/pharos-lib-types';

export { SUPPORTED_LANGUAGES };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: 'common',
    detection: {
      // i18next core calls cacheUserLanguage on EVERY resolution (including init detection), so a
      // non-empty caches list would persist the first merely-detected language and beat the live
      // browser language forever. Explicit user choices are persisted separately (see
      // `AuthenticatedLayout`'s onLanguageChange handler), so anonymous pages always follow the browser.
      caches: [],
      order: ['localStorage', 'navigator'],
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: [
      'common',
      'customers',
      'imports',
      'kpis',
      'onboarding-wizard',
      'order-creation',
      'orders',
      'settings',
      'signup',
      'tasks',
    ],
    resources: {
      ar: {
        common: arCommon,
        customers: arCustomers,
        imports: arImports,
        kpis: arKpis,
        'onboarding-wizard': arOnboardingWizard,
        'order-creation': arOrderCreation,
        orders: arOrders,
        settings: arSettings,
        signup: arSignup,
        tasks: arTasks,
      },
      en: {
        common: enCommon,
        customers: enCustomers,
        imports: enImports,
        kpis: enKpis,
        'onboarding-wizard': enOnboardingWizard,
        'order-creation': enOrderCreation,
        orders: enOrders,
        settings: enSettings,
        signup: enSignup,
        tasks: enTasks,
      },
      fr: {
        common: frCommon,
        customers: frCustomers,
        imports: frImports,
        kpis: frKpis,
        'onboarding-wizard': frOnboardingWizard,
        'order-creation': frOrderCreation,
        orders: frOrders,
        settings: frSettings,
        signup: frSignup,
        tasks: frTasks,
      },
    },
    supportedLngs: [...SUPPORTED_LANGUAGES],
  });

export default i18n;
